import React from 'react';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';

import TaskIcon from 'components/tasks/task_icon';
import Card from './card';

export default class Activity extends React.Component {
  static propTypes = {
    metadata: PropTypes.object,
    onSetAsActive: PropTypes.func
  }

  renderSubpanel = (type) => {
    const metrics = this.props.metadata[type] || { completedCount: 0, openCount: 0 };

    return (
      <div
        className={`${type === 'showing' ? '' : 'border-bottom'} p-4 text-capitalize activity-row`}
        key={type}
        name={`${type}ActivityMetricsRow`}
      >
        <div className="pl-1 pt-2">
          <TaskIcon showTooltip={false} type={type} />
        </div>
        <div className="ml-5">
          <p className="my-1 text-muted">{pluralize(type)} Logged</p>
          <h4 className="my-0">
            <strong name={`${type}SeparatedCount`}>
              {metrics.completedCount} Completed | {metrics.openCount} Scheduled
            </strong>
          </h4>
        </div>
      </div>
    );
  }

  render() {
    const { onSetAsActive, metadata, ...passThroughProps } = this.props;

    return (
      <Card
        {...passThroughProps}
        loading={!metadata}
        subtitle="Overview of tasks performed by the listing team"
        title="Activity"
      >
        {metadata &&
          <div className="activity-preview">
            {['call', 'email', 'meeting', 'showing'].map(this.renderSubpanel)}
          </div>
        }
      </Card>
    );
  }
}
